export const features = {
    "template": "template2",
    "companyName": "Security First Insurance",
    "inowEndpoint": "https://sfi-prod.xi-1-us-west-2.guidewire.net",
    "tokenIssuer": "https://sfi-inow.okta.com/oauth2/default",
    "clientId": "0oa1uc8b3au3APtMq1d8",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": true,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "changeCoverage": false,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": true,
        "customTOS": true,
        "deactivateUserOnly": true,
        "defaultLossDateTime": true,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": true,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2000-01-01",
        "mfaEnabled": false,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": true,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement",
            "Automated Pay In Full"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddress": true,
        "policyDetailsAddressTypeCd": [],
        "policyDocumentUpload": false,
        "policyForms": true,
        "policyFormsDownload": true,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": true,
        "showImageTag": true,
        "showInstallPWA": false,
        "standardPhoneLength": true,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "useGooglePlacesInReportClaimFlow": true,
        "useInsuredAttachments": true,
        "verifyAddress": true,
        "viewChangeRequests": false
    },
    "keys": {
        "googleAnalytics": null,
        "googleAnalytics4": null,
        "googleAnalyticsGwDev-deprecated": "UA-208542860-1",
        "googleAnalytics4GwDev-test": "G-FZYQHPEHGP",
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyAge27OFeCg3zMNli2jwRHMvT5RzXaPtiM"
    },
    "salesPortalUrl": "",
    "cpProducts": [
        "Homeowners"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentTenantName": "tenant.sfi",
    "paymentConfigIds": {
        "SFI": "15926701"
    },
    "paymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC",
        "UserSelect"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 4.95,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 7,
            "message": "Use at least 7 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00"
    },
    "notificationSmsNumber": "",
    "billingStatusCd": "Normal, Cancel, Legal",
    "apiResponseSizeLimit": 100,
    "_meta": {
        "build": "4.0.0-6-6e730cd",
        "commit": "6e730cdfb4b71a590560907e6c43548386d47d11",
        "company": "sfi",
        "date": "2025-06-11T16:17:04+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};